// import React, { useEffect, useRef, useState } from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import Menu from "./Components/Header/Menu";
// import Navbar from "./Components/Header/Navbar";
// import { motion, AnimatePresence } from "framer-motion";

// // Page imports
// import Home from "./Pages/Home/Home";
// import Restaurant from "./Pages/Restaurant/Restaurant";
// import Logistics from "./Pages/Logistics/Logistics";
// import Travel from "./Pages/Travel/Travel";
// import Properties from "./Pages/Properties/Properties";
// import Footer from "./Components/Footer/Footer";
// import Gallery from "./Pages/Gallery/Gallery";
// import AboutUs from "./Pages/About Us/AboutUs";
// import Branches from "./Pages/Branches/Branches";
// import ContactUs from "./Pages/Contact/ContactUs";

// const App = () => {
//   const location = useLocation();
//   const isLandingPage = location.pathname === "/";
//   const [showSplash, setShowSplash] = useState(isLandingPage);
//   const [splashDone, setSplashDone] = useState(!isLandingPage);
//   const [menuOpen, setMenuOpen] = useState(false);

//   const logoRef = useRef(null);
//   const targetRef = useRef(null);
//   const [logoCoords, setLogoCoords] = useState(null);

//   // Calculate logo position when splash is active
//   useEffect(() => {
//     if (!isLandingPage) return;

//     const timer = setTimeout(() => {
//       if (logoRef.current && targetRef.current) {
//         const logo = logoRef.current.getBoundingClientRect();
//         const target = targetRef.current.getBoundingClientRect();

//         setLogoCoords({
//           x: target.left - logo.left,
//           y: target.top - logo.top,
//           scaleX: target.width / logo.width,
//           scaleY: target.height / logo.height,
//         });
//       }
//     }, 2000);

//     return () => clearTimeout(timer);
//   }, [isLandingPage]);

//   return (
//     <div className="relative min-h-screen bg-white overflow-hidden">

//       {/* Splash animation only if on landing route */}
//       {isLandingPage && (
//         <AnimatePresence>
//           {showSplash && (
//             <motion.img
//               ref={logoRef}
//               src="https://albidayahgroups.com/Media/Logo/Al%20Bidayah%20Logo.png"
//               alt="Logo"
//               className="fixed z-50 object-contain"
//               style={{
//                 width: "128px",
//                 height: "128px",
//                 left: "50%",
//                 top: "50%",
//               }}
//               initial={{
//                 x: "-50%",
//                 y: "-50%",
//                 scale: 0.6,
//                 rotateY: 0,
//                 opacity: 0,
//               }}
//               animate={
//                 logoCoords
//                   ? {
//                     x: logoCoords.x - window.innerWidth / 2 + 64,
//                     y: logoCoords.y - window.innerHeight / 2 + 64,
//                     scaleX: logoCoords.scaleX,
//                     scaleY: logoCoords.scaleY,
//                     rotateY: 0,
//                     opacity: 1,
//                     transition: { duration: 1.2, ease: "easeInOut" },
//                   }
//                   : {
//                     rotateY: 360,
//                     scale: 1.2,
//                     opacity: 1,
//                     transition: { duration: 1.2, ease: "easeInOut" },
//                   }
//               }
//               exit={{
//                 opacity: 0,
//               }}
//               onAnimationComplete={() => {
//                 // Hide splash after animation
//                 setShowSplash(false);
//                 setTimeout(() => setSplashDone(true), 100); // show navbar after fade
//               }}
//             />
//           )}
//         </AnimatePresence>
//       )}

//       <AnimatePresence>
//         {splashDone && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0.2, ease: "easeOut" }}
//           >
//             <Navbar
//               showSplash={showSplash}
//               toggleMenu={() => setMenuOpen(!menuOpen)}
//               targetRef={targetRef}
//             />
//           </motion.div>
//         )}
//       </AnimatePresence>


//       <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
//       <AnimatePresence mode="wait">
//         {splashDone && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0, ease: "easeOut" }}
//           >
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/restaurant" element={<Restaurant />} />
//               <Route path="/logistics" element={<Logistics />} />
//               <Route path="/travel" element={<Travel />} />
//               <Route path="/properties" element={<Properties />} />
//               <Route path="/gallery" element={<Gallery />} />
//               <Route path="/about-us" element={<AboutUs />} />
//               <Route path="/branches" element={<Branches />} />
//               <Route path="/contact" element={<ContactUs />} />
//               <Route path="*" element={<Navigate to="/" />} />
//             </Routes>
//             <Footer />
//           </motion.div>
//         )}
//       </AnimatePresence>

//     </div>
//   );
// };

// export default App;



// import React, { useEffect, useRef, useState } from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import Menu from "./Components/Header/Menu";
// import Navbar from "./Components/Header/Navbar";
// import { motion, AnimatePresence } from "framer-motion";

// // Page imports
// import Home from "./Pages/Home/Home";
// import Restaurant from "./Pages/Restaurant/Restaurant";
// import Logistics from "./Pages/Logistics/Logistics";
// import Travel from "./Pages/Travel/Travel";
// import Properties from "./Pages/Properties/Properties";
// import Footer from "./Components/Footer/Footer";
// import Gallery from "./Pages/Gallery/Gallery";
// import AboutUs from "./Pages/About Us/AboutUs";
// import Branches from "./Pages/Branches/Branches";
// import ContactUs from "./Pages/Contact/ContactUs";

// const App = () => {
//   const location = useLocation();
//   const isLandingPage = location.pathname === "/";
//   const [showSplash, setShowSplash] = useState(isLandingPage);
//   const [splashDone, setSplashDone] = useState(!isLandingPage);
//   const [menuOpen, setMenuOpen] = useState(false);

//   const logoRef = useRef(null);
//   const targetRef = useRef(null);
//   const [logoCoords, setLogoCoords] = useState(null);

//   // Calculate logo position when splash is active
//   useEffect(() => {
//     if (!isLandingPage) return;

//     const timer = setTimeout(() => {
//       if (logoRef.current && targetRef.current) {
//         const logo = logoRef.current.getBoundingClientRect();
//         const target = targetRef.current.getBoundingClientRect();

//         setLogoCoords({
//           x: target.left - logo.left,
//           y: target.top - logo.top,
//           scaleX: target.width / logo.width,
//           scaleY: target.height / logo.height,
//         });
//       }
//     }, 2000);

//     return () => clearTimeout(timer);
//   }, [isLandingPage]);

//   return (
//     <div className="relative min-h-screen bg-black overflow-hidden">
//       {/* Splash animation only if on landing route */}
//       {isLandingPage && (
//         <AnimatePresence>
//           {showSplash && (
//             <motion.img
//               ref={logoRef}
//               src="https://albidayahgroups.com/Media/Logo/RAB%20logo%203D.png"
//               alt="Logo"
//               className="fixed z-50 object-contain"
//               style={{
//                 width: "500px",
//                 height: "500px",
//                 left: "50%",
//                 top: "50%",
//               }}
//               initial={{
//                 x: "-50%",
//                 y: "-50%",
//                 scale: 0.6,
//                 rotateY: 0,
//                 opacity: 0,
//               }}
//               animate={
//                 logoCoords
//                   ? {
//                       x: logoCoords.x - window.innerWidth / 2 + 64,
//                       y: logoCoords.y - window.innerHeight / 2 + 64,
//                       scaleX: logoCoords.scaleX,
//                       scaleY: logoCoords.scaleY,
//                       rotateY: 0,
//                       opacity: 1,
//                       transition: { duration: 1.2, ease: "easeInOut" },
//                     }
//                   : {
//                       rotateY: 360,
//                       scale: 1.2,
//                       opacity: 1,
//                       transition: { duration: 1.2, ease: "easeInOut" },
//                     }
//               }
//               exit={{
//                 x: logoCoords
//                   ? logoCoords.x - window.innerWidth / 2 + 64
//                   : -window.innerWidth - 20,
//                 y: logoCoords
//                   ? logoCoords.y - window.innerHeight / 2 + 64
//                   : -window.innerHeight - 20,
//                 scaleX: 1,
//                 scaleY: 1,
//                 opacity: 0,
//                 transition: { duration: 1.2, ease: "easeInOut" },
//               }}
//               onAnimationComplete={() => {
//                 // Hide splash after animation
//                 setShowSplash(false);
//                 setTimeout(() => setSplashDone(true), 100); // show navbar after fade
//               }}
//             />
//           )}
//         </AnimatePresence>
//       )}

//       <AnimatePresence>
//         {splashDone && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0.2, ease: "easeOut" }}
//           >
//             <Navbar
//               showSplash={showSplash}
//               toggleMenu={() => setMenuOpen(!menuOpen)}
//               targetRef={targetRef}
//             />
//           </motion.div>
//         )}
//       </AnimatePresence>

//       <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
//       <AnimatePresence mode="wait">
//         {splashDone && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0, ease: "easeOut" }}
//           >
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/restaurant" element={<Restaurant />} />
//               <Route path="/logistics" element={<Logistics />} />
//               <Route path="/travel" element={<Travel />} />
//               <Route path="/properties" element={<Properties />} />
//               <Route path="/gallery" element={<Gallery />} />
//               <Route path="/about-us" element={<AboutUs />} />
//               <Route path="/branches" element={<Branches />} />
//               <Route path="/contact" element={<ContactUs />} />
//               <Route path="*" element={<Navigate to="/" />} />
//             </Routes>
//             <Footer />
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default App;




// import React, { useEffect, useRef, useState } from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import Menu from "./Components/Header/Menu";
// import Navbar from "./Components/Header/Navbar";
// import { motion, AnimatePresence } from "framer-motion";

// // Page imports
// import Home from "./Pages/Home/Home";
// import Restaurant from "./Pages/Restaurant/Restaurant";
// import Logistics from "./Pages/Logistics/Logistics";
// import Travel from "./Pages/Travel/Travel";
// import Properties from "./Pages/Properties/Properties";
// import Footer from "./Components/Footer/Footer";
// import Gallery from "./Pages/Gallery/Gallery";
// import AboutUs from "./Pages/About Us/AboutUs";
// import Branches from "./Pages/Branches/Branches";
// import ContactUs from "./Pages/Contact/ContactUs";

// const App = () => {
//   const location = useLocation();
//   const isLandingPage = location.pathname === "/";
//   const [showSplash, setShowSplash] = useState(isLandingPage);
//   const [splashDone, setSplashDone] = useState(!isLandingPage);
//   const logoRef = useRef(null);
//   const targetRef = useRef(null);
//   const [menuOpen, setMenuOpen] = useState(false);

//   // 🔽 Close menu when route changes
//   useEffect(() => {
//     setMenuOpen(false);
//   }, [location.pathname]);

//   // Splash screen fallback (optional)
//   useEffect(() => {
//     if (isLandingPage) {
//       const fallback = setTimeout(() => {
//         setShowSplash(false);
//         setSplashDone(true);
//       }, 5000);
//       return () => clearTimeout(fallback);
//     }
//   }, [isLandingPage]);

//   return (
//     <div className="relative overflow-hidden">

//       {/* Splash Screen */}
//       {isLandingPage && (

// <AnimatePresence exitBeforeEnter>
//   {showSplash && (
//     <motion.div
//       className="fixed inset-0 bg-black z-50 flex items-center justify-center"
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       exit={{ opacity: 0 }}
//             transition={{ duration: 0, ease: "easeOut" }}
//     >
//       <video
//   src="https://albidayahgroups.com/Media/Videos/RAB3Dlogo_ec.mp4"
//   poster="https://albidayahgroups.com/Media/Splash_Thumbnail_Logo.jpg"
//   autoPlay
//   muted
//   playsInline
//   controls={false}
//   // onEnded={() => {
//   //   setShowSplash(false);
//   //   setSplashDone(true);
//   // }}
//   style={{ width: "100%", height: "100%", objectFit: "contain" }}
// />
//     </motion.div>
//   )}
// </AnimatePresence>

//       )}

//       {/* {isLandingPage && (
//   <AnimatePresence>
//     {showSplash && (
//       <motion.div
//         className="fixed inset-0 bg-black z-50 flex items-center justify-center"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//       >
//         <img
//           src="https://albidayahgroups.com/Media/RAB3Dlogo_1.gif"
//           alt="Logo Splash"
//           className="w-full object-contain"
//           onLoad={() => {
//             // Simulate duration of GIF (e.g., 3 seconds)
//             setTimeout(() => {
//               setShowSplash(false);
//               setSplashDone(true);
//             }, 4500); // Adjust the timeout duration to match your GIF's duration
//           }}
//         />
//       </motion.div>
//     )}
//   </AnimatePresence>
// )} */}


//       {/* Navbar after splash */}
//       <AnimatePresence>
//         {splashDone && (
//           <motion.div
//             initial={{ opacity: 1 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0, ease: "easeOut" }}
//           >
//             <Navbar
//               showSplash={showSplash}
//               toggleMenu={() => setMenuOpen(!menuOpen)}
//               targetRef={targetRef}
//             />
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Mobile Menu */}
//       <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

//       {/* Routes and Footer */}
//       <AnimatePresence mode="wait">
//         {splashDone && (
//           <motion.div
//             key={location.pathname}
//             initial={{ opacity: 1 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0, ease: "easeOut" }}
//           >
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/restaurant" element={<Restaurant />} />
//               <Route path="/logistics" element={<Logistics />} />
//               <Route path="/travel" element={<Travel />} />
//               <Route path="/properties" element={<Properties />} />
//               <Route path="/gallery" element={<Gallery />} />
//               <Route path="/about-us" element={<AboutUs />} />
//               <Route path="/branches" element={<Branches />} />
//               <Route path="/contact" element={<ContactUs />} />
//               <Route path="*" element={<Navigate to="/" />} />
//             </Routes>
//             <Footer />
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default App;




// import React, { useEffect, useRef, useState } from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import Menu from "./Components/Header/Menu";
// import Navbar from "./Components/Header/Navbar";
// import { motion, AnimatePresence } from "framer-motion";

// // Page imports
// import Home from "./Pages/Home/Home";
// import Restaurant from "./Pages/Restaurant/Restaurant";
// import Logistics from "./Pages/Logistics/Logistics";
// import Travel from "./Pages/Travel/Travel";
// import Properties from "./Pages/Properties/Properties";
// import Footer from "./Components/Footer/Footer";
// import Gallery from "./Pages/Gallery/Gallery";
// import AboutUs from "./Pages/About Us/AboutUs";
// import Branches from "./Pages/Branches/Branches";
// import ContactUs from "./Pages/Contact/ContactUs";

// const App = () => {
//   const location = useLocation();
//   const isLandingPage = location.pathname === "/";
//   const [showSplash, setShowSplash] = useState(isLandingPage);
//   const [splashDone, setSplashDone] = useState(!isLandingPage);
//   const targetRef = useRef(null);
//   const [menuOpen, setMenuOpen] = useState(false);

//   // 🔽 Close menu when route changes
//   useEffect(() => {
//     setMenuOpen(false);
//   }, [location.pathname]);

//   return (
//     <div className="relative overflow-hidden">
//       {/* Splash Screen */}
//       {isLandingPage && (
//         <AnimatePresence mode="wait">
//           {showSplash && (
//             <motion.div
//               className="fixed inset-0 bg-black z-50 flex items-center justify-center"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               transition={{ duration: 0.5, ease: "easeOut" }}
//             >
//               <video
//                 src="https://albidayahgroups.com/Media/Videos/logo_1.mp4"
//                 poster="https://albidayahgroups.com/Media/Splash_Thumbnail_Logo.jpg"
//                 autoPlay
//                 muted
//                 playsInline
//                 controls={false}
//                 onEnded={() => {
//                   setShowSplash(false);
//                   setSplashDone(true);
//                 }}
//                 style={{ width: "100%", height: "100%", objectFit: "contain" }}
//               />
//             </motion.div>
//           )}
//         </AnimatePresence>
//       )}

//       {/* Navbar after splash */}
//       <AnimatePresence mode="wait">
//         {splashDone && (
//           <motion.div
//             // initial={{ opacity: 1 }}
//             // animate={{ opacity: 1 }}
//             // exit={{ opacity: 0 }}
//             // transition={{ duration: 0.5, ease: "easeOut" }}
//           >
//             <Navbar
//               showSplash={showSplash}
//               toggleMenu={() => setMenuOpen(!menuOpen)}
//               targetRef={targetRef}
//             />
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Mobile Menu */}
//       <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

//       {/* Routes and Footer */}
//       <AnimatePresence mode="wait">
//         {splashDone && (
//           <motion.div
//             key={location.pathname}
//             // initial={{ opacity: 0 }}
//             // animate={{ opacity: 1 }}
//             // exit={{ opacity: 0 }}
//             // transition={{ duration: 0.5, ease: "easeOut" }}
//           >
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/restaurant" element={<Restaurant />} />
//               <Route path="/logistics" element={<Logistics />} />
//               <Route path="/travel" element={<Travel />} />
//               <Route path="/properties" element={<Properties />} />
//               <Route path="/gallery" element={<Gallery />} />
//               <Route path="/about-us" element={<AboutUs />} />
//               <Route path="/branches" element={<Branches />} />
//               <Route path="/contact" element={<ContactUs />} />
//               <Route path="*" element={<Navigate to="/" />} />
//             </Routes>
//             <Footer />
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default App;




// import React, { useEffect, useRef, useState } from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import Menu from "./Components/Header/Menu";
// import Navbar from "./Components/Header/Navbar";
// import { motion, AnimatePresence } from "framer-motion";

// // Page imports
// import Home from "./Pages/Home/Home";
// import Restaurant from "./Pages/Restaurant/Restaurant";
// import Logistics from "./Pages/Logistics/Logistics";
// import Travel from "./Pages/Travel/Travel";
// import Properties from "./Pages/Properties/Properties";
// import Footer from "./Components/Footer/Footer";
// import Gallery from "./Pages/Gallery/Gallery";
// import AboutUs from "./Pages/About Us/AboutUs";
// import Branches from "./Pages/Branches/Branches";
// import ContactUs from "./Pages/Contact/ContactUs";
// import ScrollToTop from "./ScrollToTop";
// import MetaDescriptionAndKeywords from "./Components/Meta/Metadescription";

// const App = () => {
//   const location = useLocation();
//   const isLandingPage = location.pathname === "/";
//   const [showSplash, setShowSplash] = useState(isLandingPage);
//   const targetRef = useRef(null);
//   const [menuOpen, setMenuOpen] = useState(false);

//   // 🔽 Close menu when route changes
//   useEffect(() => {
//     setMenuOpen(false);
//   }, [location.pathname]);

//   const currentPageLink = window.location.pathname;

//   return (
//     <div className="relative overflow-hidden">

//       <MetaDescriptionAndKeywords pageLink={currentPageLink} />

//       <ScrollToTop />
//       {/* Splash Screen */}
//       {isLandingPage && (
//         <AnimatePresence mode="wait">
//           {showSplash && (
//             <motion.div
//               className="fixed inset-0 bg-black z-[2000] flex items-center justify-center"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               <video
//                 src="https://albidayahgroups.com/Media/Videos/logo_1.mp4"
//                 poster="https://albidayahgroups.com/Media/Splash_Thumbnail_Logo.jpg"
//                 autoPlay
//                 muted
//                 playsInline
//                 controls={false}
//                 onEnded={() => setShowSplash(false)}
//                 style={{ width: "100%", height: "100%", objectFit: "contain" }}
//               />
//             </motion.div>
//           )}
//         </AnimatePresence>
//       )}

//       {/* Navbar */}
//       <Navbar
//         showSplash={showSplash}
//         toggleMenu={() => setMenuOpen(!menuOpen)}
//         targetRef={targetRef}
//       />

//       {/* Mobile Menu */}
//       <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

//       {/* Routes and Footer */}
//       <div key={location.pathname}>
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/restaurant" element={<Restaurant />} />
//           <Route path="/logistics" element={<Logistics />} />
//           <Route path="/travel" element={<Travel />} />
//           <Route path="/properties" element={<Properties />} />
//           <Route path="/gallery" element={<Gallery />} />
//           <Route path="/about-us" element={<AboutUs />} />
//           <Route path="/branches" element={<Branches />} />
//           <Route path="/contact" element={<ContactUs />} />
//           <Route path="*" element={<Navigate to="/" />} />
//         </Routes>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default App;




import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

import Menu from "./Components/Header/Menu";
import Navbar from "./Components/Header/Navbar";
import Footer from "./Components/Footer/Footer";
import ScrollToTop from "./ScrollToTop";
import MetaDescriptionAndKeywords from "./Components/Meta/Metadescription";

// Page imports
import Home from "./Pages/Home/Home";
import Restaurant from "./Pages/Restaurant/Restaurant";
import Logistics from "./Pages/Logistics/Logistics";
import Travel from "./Pages/Travel/Travel";
import Properties from "./Pages/Properties/Properties";
import Gallery from "./Pages/Gallery/Gallery";
import AboutUs from "./Pages/About Us/AboutUs";
import Branches from "./Pages/Branches/Branches";
import ContactUs from "./Pages/Contact/ContactUs";

const App = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";
  const [showSplash, setShowSplash] = useState(isLandingPage);
  const [menuOpen, setMenuOpen] = useState(false);
  const targetRef = useRef(null);

  // ✅ Close menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // ✅ Use location.pathname directly (don’t use window)
  const currentPageLink = location.pathname;

  return (
    <div className="relative overflow-hidden">
      {/* ✅ Dynamic SEO Tags */}
      <MetaDescriptionAndKeywords pageLink={currentPageLink} />

      {/* Scroll To Top on Navigation */}
      <ScrollToTop />

      {/* Splash Screen */}
      {isLandingPage && (
        <AnimatePresence mode="wait">
          {showSplash && (
            <motion.div
              className="fixed inset-0 bg-black z-[2000] flex items-center justify-center"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <video
                src="https://albidayahgroups.com/Media/Videos/logo_1.mp4"
                poster="https://albidayahgroups.com/Media/Splash_Thumbnail_Logo.jpg"
                autoPlay
                muted
                playsInline
                controls={false}
                onEnded={() => setShowSplash(false)}
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </motion.div>
          )}
        </AnimatePresence>
      )}

      {/* Navbar */}
      <Navbar
        showSplash={showSplash}
        toggleMenu={() => setMenuOpen(!menuOpen)}
        targetRef={targetRef}
      />

      {/* Mobile Menu */}
      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      {/* Routes and Footer */}
      <div key={location.pathname}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/restaurant" element={<Restaurant />} />
          <Route path="/logistics" element={<Logistics />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
    </div>
  );
};

export default App;
